module.exports = __webpack_public_path__ + "static/media/9DuMY9h47eRVKMfGcB7P8DJyhGDYzcm4vjpRgARM.ffd14f78.webp";